import {
  FETCH_MISC_PRODUCT_PENDING,
  FETCH_MISC_PRODUCT_REJECTED,
  FETCH_MISC_PRODUCT_FULFILLED,
} from "../constants/miscProduct";

const initialState = {
  success: false,
  pending: false,
  product: {},
  error: {},
};

export const miscProduct = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MISC_PRODUCT_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        product: {},
        error: {},
      };

    case FETCH_MISC_PRODUCT_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_MISC_PRODUCT_FULFILLED:
      return {
        ...state,
        product: action.response,
        pending: false,
        error: {},
        success: true,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/miscProduct.js